// extracted by mini-css-extract-plugin
export default {"main":"SkxDu","container":"_1sX84","title":"mUsyS","titleThin":"_5Vf1E","skeleton-progress":"SR-LS"};